import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import arenaImg from './images/arena.jpeg'; // Make sure this path matches your image location
import './App.css';
import './MainContainer.css'; // Import shared container styles
import BookingCalendar from './BookingCalendar';
import BookingForm from './BookingForm';
import AdminLogin from './Instructor'
import CalendarDay from './CalendarDay';
import AdminDashboard from './AdminDashboard'; // Make sure this import is present
import LessonSchedule from './LessonSchedule';
import Header from './Header';
import CreateAccount from './CreateAccount';
import ConfirmBookings from './ConfirmBookings'; // Import ConfirmBookings component
import ViewBookings from './ViewBookings'; // Import ViewBookings component
import RegularSchedule from './RegularSchedule'; // Import RegularSchedule component
// Import or define your API utility here
import api from './helpers/Api'; // Make sure you have an api.js file exporting the login function
import {useAuth} from './hooks/useAuth';
import {AuthProvider} from "./context/AuthContext";

//8jnkxmcpehvdusyglqb

function Home() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const auth = useAuth();
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);
			setStatus(null);
			auth.login({username: username, password, rememberMe: false})
				?.then(() => {
					navigate('/admin-dashboard');
				})
				.catch((error) => {
					setSubmitting(false);
					setStatus(error instanceof Error ? error.message : error);
				});

    /*const result = await api.login(username, password);
    
    // Simple hardcoded check for demonstration
    if (result && result.success) {
      setError('');
      // Redirect to admin dashboard
      navigate('/admin-dashboard');
    } else {
      setError('Invalid username or password');
    }*/
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `url(${arenaImg}) center center/cover no-repeat #f8f6f2`,
        backgroundAttachment: "fixed",
        width: "100vw", // Ensure full viewport width
        boxSizing: "border-box",
        overflowX: "hidden"
      }}
    >
      <form
        style={{
          background: "#fff",
          padding: "48px 32px",
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(40,44,52,0.15)",
          minWidth: "320px",
          maxWidth: "380px",
          width: "90vw", // Responsive width for mobile
          maxWidth: "380px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxSizing: "border-box"
        }}
        onSubmit={handleSubmit}
      >
        <Header style={{ marginBottom: "20px" }} />
        <AuthProvider>
        <h2 style={{ marginBottom: 2, marginTop: "2px" }}>Login</h2>
        {/*
        <div style={{ marginBottom: 18, marginTop: 6 }}>
          or <a
            href="#"
            style={{
              color: "#1976d2",
              textDecoration: "underline",
              fontSize: "1rem",
              cursor: "pointer"
            }}
            onClick={e => {
              e.preventDefault();
              navigate('/create-account');
            }}
          >
            Create account
          </a>
        </div>
        */}
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          style={{
            marginBottom: 16,
            padding: "10px",
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{
            marginBottom: 16,
            padding: "10px",
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
          required
        />
       
        {error && <div style={{ color: "red", marginBottom: 12 }}>{error}</div>}
        <button
          type="submit"
          style={{
            background: "#282c34",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "10px 22px",
            fontWeight: 700,
            fontSize: "1rem",
            cursor: "pointer"
          }}
        >
          Login
        </button>
         <div style={{ width: "100%", textAlign: "right", marginBottom: 16, marginTop: 16 }}>
          <a
            href="#"
            style={{
              color: "#1976d2",
              textDecoration: "underline",
              fontSize: "0.98rem",
              cursor: "pointer"
            }}
            onClick={e => {
              e.preventDefault();
              alert('Password reset functionality coming soon!');
            }}
          >
            Forgotten your password?
          </a>
        </div>
        </AuthProvider>
      </form>
    </div>

    /*<div className="home-page" style={{ position: "relative", minHeight: "100vh" }}>
      <div className="main-container">
        <img src={logo} className="App-logo" alt="logo" />
        <button
          style={{
            marginTop: "32px",
            background: "#282c34",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "18px 44px",
            fontWeight: 700,
            fontSize: "1.3rem",
            cursor: "pointer",
            transition: "background 0.2s",
            marginBottom: "16px"
          }}
          onClick={() => navigate('/bookingCalendar', { state: { mode: 'lesson' } })}
        >
          Book Lesson
        </button>
        <button
          style={{
            background: "#282c34",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "18px 44px",
            fontWeight: 700,
            fontSize: "1.3rem",
            cursor: "pointer",
            transition: "background 0.2s",
            marginBottom: "16px"
          }}
          onClick={() => navigate('/bookingCalendar', { state: { mode: 'school' } })}
        >
          Book School
        </button>
        
        <button
          className="admin-topright-btn"
          style={{
            marginTop: "12px",
            position: "static",
            background: "#282c34",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "18px 44px",
            fontWeight: 700,
            fontSize: "1.3rem",
            cursor: "pointer",
            zIndex: 100,
            marginTop: "50px",
          }}
          onClick={() => navigate('/admin')}
        >
          Admin
        </button>
      </div>
    </div>*/
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bookingCalendar" element={<BookingCalendar />} />
          <Route path="/calendarDay" element={<CalendarDay />} />
          <Route path="/bookingForm" element={<BookingForm />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/lesson-schedule" element={<LessonSchedule />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/confirm-bookings" element={<ConfirmBookings />} />
          <Route path="/view-bookings" element={<ViewBookings />} />
          <Route path="/regular-schedule" element={<RegularSchedule />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
